const MAP004 = [
  {
    name: "ARG1/RS1",
    lat: 11.107956,
    lng: 122.765528,
    description:
      "<table><tr><td>Name of Station</td><td>ARG1/RS1</td></tr><tr><td>Country</td><td>Philippines</td></tr><tr><td>Sub-National</td><td>Mt. Cańapasan</td></tr><tr><td>Type of Station</td><td></td></tr><tr><td>Type of Operation</td><td></td></tr><tr><td>Technical Specs</td><td></td></tr><tr><td>Data transmission</td><td></td></tr><tr><td>Date of establishment</td><td>April 17- 28, 2017 </td></tr><tr><td>Source of Funds</td><td>INCOIS</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "ARG2/RS2",
    lat: 11.081944,
    lng: 122.400555,
    description:
      "<table><tr><td>Name of Station</td><td>ARG2/RS2</td></tr><tr><td>Country</td><td>Philippines</td></tr><tr><td>Sub-National</td><td>Bagongbong Brgy Hall</td></tr><tr><td>Type of Station</td><td></td></tr><tr><td>Type of Operation</td><td></td></tr><tr><td>Technical Specs</td><td></td></tr><tr><td>Data transmission</td><td></td></tr><tr><td>Date of establishment</td><td>April 17- 28, 2018</td></tr><tr><td>Source of Funds</td><td>INCOIS</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "ARG3/RS3",
    lat: 11.0255556,
    lng: 122.4116666,
    description:
      "<table><tr><td>Name of Station</td><td>ARG3/RS3</td></tr><tr><td>Country</td><td>Philippines</td></tr><tr><td>Sub-National</td><td>Anhawan RG</td></tr><tr><td>Type of Station</td><td></td></tr><tr><td>Type of Operation</td><td></td></tr><tr><td>Technical Specs</td><td></td></tr><tr><td>Data transmission</td><td></td></tr><tr><td>Date of establishment</td><td>April 17- 28, 2019</td></tr><tr><td>Source of Funds</td><td>INCOIS</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "ARG4",
    lat: 10.94534,
    lng: 122.64131,
    description:
      "<table><tr><td>Name of Station</td><td>ARG4</td></tr><tr><td>Country</td><td>Philippines</td></tr><tr><td>Sub-National</td><td></td></tr><tr><td>Type of Station</td><td></td></tr><tr><td>Type of Operation</td><td></td></tr><tr><td>Technical Specs</td><td></td></tr><tr><td>Data transmission</td><td></td></tr><tr><td>Date of establishment</td><td>April 17- 28, 2020</td></tr><tr><td>Source of Funds</td><td>INCOIS</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "COMBI1",
    lat: 10.84796,
    lng: 122.65053,
    description:
      "<table><tr><td>Name of Station</td><td>COMBI1</td></tr><tr><td>Country</td><td>Philippines</td></tr><tr><td>Sub-National</td><td>Penaflorida-Deza RG and WL</td></tr><tr><td>Type of Station</td><td></td></tr><tr><td>Type of Operation</td><td></td></tr><tr><td>Technical Specs</td><td></td></tr><tr><td>Data transmission</td><td></td></tr><tr><td>Date of establishment</td><td>April 17- 28, 2021</td></tr><tr><td>Source of Funds</td><td>INCOIS</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "COMBI2",
    lat: 10.90955,
    lng: 122.68589,
    description:
      "<table><tr><td>Name of Station</td><td>COMBI2</td></tr><tr><td>Country</td><td>Philippines</td></tr><tr><td>Sub-National</td><td>Pototan RG and WL</td></tr><tr><td>Type of Station</td><td></td></tr><tr><td>Type of Operation</td><td></td></tr><tr><td>Technical Specs</td><td></td></tr><tr><td>Data transmission</td><td></td></tr><tr><td>Date of establishment</td><td>April 17- 28, 2022</td></tr><tr><td>Source of Funds</td><td>INCOIS</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "COMBI3",
    lat: 11.00341,
    lng: 122.66695,
    description:
      "<table><tr><td>Name of Station</td><td>COMBI3</td></tr><tr><td>Country</td><td>Philippines</td></tr><tr><td>Sub-National</td><td>Dingle RG & WL</td></tr><tr><td>Type of Station</td><td></td></tr><tr><td>Type of Operation</td><td></td></tr><tr><td>Technical Specs</td><td></td></tr><tr><td>Data transmission</td><td></td></tr><tr><td>Date of establishment</td><td>April 17- 28, 2023</td></tr><tr><td>Source of Funds</td><td>INCOIS</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "COMBI4",
    lat: 10.95288,
    lng: 122.50433,
    description:
      "<table><tr><td>Name of Station</td><td>COMBI4</td></tr><tr><td>Country</td><td>Philippines</td></tr><tr><td>Sub-National</td><td>Suague RG & WL</td></tr><tr><td>Type of Station</td><td></td></tr><tr><td>Type of Operation</td><td></td></tr><tr><td>Technical Specs</td><td></td></tr><tr><td>Data transmission</td><td></td></tr><tr><td>Date of establishment</td><td>April 17- 28, 2024</td></tr><tr><td>Source of Funds</td><td>INCOIS</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "COMBI5",
    lat: 11.1196,
    lng: 122.53849,
    description:
      "<table><tr><td>Name of Station</td><td>COMBI5</td></tr><tr><td>Country</td><td>Philippines</td></tr><tr><td>Sub-National</td><td>Calinog RG & WL</td></tr><tr><td>Type of Station</td><td></td></tr><tr><td>Type of Operation</td><td></td></tr><tr><td>Technical Specs</td><td></td></tr><tr><td>Data transmission</td><td></td></tr><tr><td>Date of establishment</td><td>April 17- 28, 2025</td></tr><tr><td>Source of Funds</td><td>INCOIS</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "COMBI6",
    lat: 11.10203,
    lng: 122.64104,
    description:
      "<table><tr><td>Name of Station</td><td>COMBI6</td></tr><tr><td>Country</td><td>Philippines</td></tr><tr><td>Sub-National</td><td>Passi RG & WL</td></tr><tr><td>Type of Station</td><td></td></tr><tr><td>Type of Operation</td><td></td></tr><tr><td>Technical Specs</td><td></td></tr><tr><td>Data transmission</td><td></td></tr><tr><td>Date of establishment</td><td>April 17- 28, 2026</td></tr><tr><td>Source of Funds</td><td>INCOIS</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "COMBI7",
    lat: 10.693459,
    lng: 122.480121,
    description:
      "<table><tr><td>Name of Station</td><td>COMBI7</td></tr><tr><td>Country</td><td>Philippines</td></tr><tr><td>Sub-National</td><td>Batiano RG & WL</td></tr><tr><td>Type of Station</td><td></td></tr><tr><td>Type of Operation</td><td></td></tr><tr><td>Technical Specs</td><td></td></tr><tr><td>Data transmission</td><td></td></tr><tr><td>Date of establishment</td><td>April 17- 28, 2027</td></tr><tr><td>Source of Funds</td><td>INCOIS</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "WLG1",
    lat: 10.70174,
    lng: 122.560974,
    description:
      "<table><tr><td>Name of Station</td><td>WLG1</td></tr><tr><td>Country</td><td>Philippines</td></tr><tr><td>Sub-National</td><td>Jalandoni WL</td></tr><tr><td>Type of Station</td><td></td></tr><tr><td>Type of Operation</td><td></td></tr><tr><td>Technical Specs</td><td></td></tr><tr><td>Data transmission</td><td></td></tr><tr><td>Date of establishment</td><td>April 17- 28, 2028</td></tr><tr><td>Source of Funds</td><td>INCOIS</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "WLG2",
    lat: 10.729606,
    lng: 122.558347,
    description:
      "<table><tr><td>Name of Station</td><td>WLG2</td></tr><tr><td>Country</td><td>Philippines</td></tr><tr><td>Sub-National</td><td>Jaro WL</td></tr><tr><td>Type of Station</td><td></td></tr><tr><td>Type of Operation</td><td></td></tr><tr><td>Technical Specs</td><td></td></tr><tr><td>Data transmission</td><td></td></tr><tr><td>Date of establishment</td><td>April 17- 28, 2029</td></tr><tr><td>Source of Funds</td><td>INCOIS</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "WLG3",
    lat: 10.76559,
    lng: 122.551189,
    description:
      "<table><tr><td>Name of Station</td><td>WLG3</td></tr><tr><td>Country</td><td>Philippines</td></tr><tr><td>Sub-National</td><td>Anilao WL</td></tr><tr><td>Type of Station</td><td></td></tr><tr><td>Type of Operation</td><td></td></tr><tr><td>Technical Specs</td><td></td></tr><tr><td>Data transmission</td><td></td></tr><tr><td>Date of establishment</td><td>April 17- 28, 2030</td></tr><tr><td>Source of Funds</td><td>INCOIS</td></tr><tr><td>Status</td><td>Operational</td></tr></table>",
  },
  {
    name: "Pyay WLS",
    lat: 18.8,
    lng: 95.22,
    description:
      "<table><tr><td>Name of Station</td><td>Pyay WLS</td></tr><tr><td>Country</td><td>Myanmar</td></tr><tr><td>Sub-National</td><td>Ayeyarwady</td></tr><tr><td>Type of Station</td><td></td></tr><tr><td>Type of Operation</td><td></td></tr><tr><td>Technical Specs</td><td></td></tr><tr><td>Data transmission</td><td></td></tr><tr><td>Date of establishment</td><td></td></tr><tr><td>Source of Funds</td><td></td></tr><tr><td>Status</td><td></td></tr></table>",
  },
  {
    name: "Magway WLS",
    lat: 20.13,
    lng: 94.92,
    description:
      "<table><tr><td>Name of Station</td><td>Magway WLS</td></tr><tr><td>Country</td><td>Myanmar</td></tr><tr><td>Sub-National</td><td>Ayeyarwady</td></tr><tr><td>Type of Station</td><td></td></tr><tr><td>Type of Operation</td><td></td></tr><tr><td>Technical Specs</td><td></td></tr><tr><td>Data transmission</td><td></td></tr><tr><td>Date of establishment</td><td></td></tr><tr><td>Source of Funds</td><td></td></tr><tr><td>Status</td><td></td></tr></table>",
  },
  {
    name: "Chauk WLS",
    lat: 20.9,
    lng: 94.83,
    description:
      "<table><tr><td>Name of Station</td><td>Chauk WLS</td></tr><tr><td>Country</td><td>Myanmar</td></tr><tr><td>Sub-National</td><td>Ayeyarwady</td></tr><tr><td>Type of Station</td><td></td></tr><tr><td>Type of Operation</td><td></td></tr><tr><td>Technical Specs</td><td></td></tr><tr><td>Data transmission</td><td></td></tr><tr><td>Date of establishment</td><td></td></tr><tr><td>Source of Funds</td><td></td></tr><tr><td>Status</td><td></td></tr></table>",
  },
  {
    name: "Pakokku WLS",
    lat: 21.33,
    lng: 95.08,
    description:
      "<table><tr><td>Name of Station</td><td>Pakokku WLS</td></tr><tr><td>Country</td><td>Myanmar</td></tr><tr><td>Sub-National</td><td>Ayeyarwady</td></tr><tr><td>Type of Station</td><td></td></tr><tr><td>Type of Operation</td><td></td></tr><tr><td>Technical Specs</td><td></td></tr><tr><td>Data transmission</td><td></td></tr><tr><td>Date of establishment</td><td></td></tr><tr><td>Source of Funds</td><td></td></tr><tr><td>Status</td><td></td></tr></table>",
  },
  {
    name: "Monywa WLS",
    lat: 22.1,
    lng: 95.13,
    description:
      "<table><tr><td>Name of Station</td><td>Monywa WLS</td></tr><tr><td>Country</td><td>Myanmar</td></tr><tr><td>Sub-National</td><td>Chindwin</td></tr><tr><td>Type of Station</td><td></td></tr><tr><td>Type of Operation</td><td></td></tr><tr><td>Technical Specs</td><td></td></tr><tr><td>Data transmission</td><td></td></tr><tr><td>Date of establishment</td><td></td></tr><tr><td>Source of Funds</td><td></td></tr><tr><td>Status</td><td></td></tr></table>",
  },
  {
    name: "Sagaing WLS",
    lat: 21.87,
    lng: 95.98,
    description:
      "<table><tr><td>Name of Station</td><td>Sagaing WLS</td></tr><tr><td>Country</td><td>Myanmar</td></tr><tr><td>Sub-National</td><td>Ayeyarwady</td></tr><tr><td>Type of Station</td><td></td></tr><tr><td>Type of Operation</td><td></td></tr><tr><td>Technical Specs</td><td></td></tr><tr><td>Data transmission</td><td></td></tr><tr><td>Date of establishment</td><td></td></tr><tr><td>Source of Funds</td><td></td></tr><tr><td>Status</td><td></td></tr></table>",
  },
  {
    name: "NgathaingChaung WLS",
    lat: 17.4,
    lng: 95.083,
    description:
      "<table><tr><td>Name of Station</td><td>NgathaingChaung WLS</td></tr><tr><td>Country</td><td>Myanmar</td></tr><tr><td>Sub-National</td><td>Ngawun</td></tr><tr><td>Type of Station</td><td></td></tr><tr><td>Type of Operation</td><td></td></tr><tr><td>Technical Specs</td><td></td></tr><tr><td>Data transmission</td><td></td></tr><tr><td>Date of establishment</td><td></td></tr><tr><td>Source of Funds</td><td></td></tr><tr><td>Status</td><td></td></tr></table>",
  },
  {
    name: "YeniWLS",
    lat: 18.9,
    lng: 96.38,
    description:
      "<table><tr><td>Name of Station</td><td>YeniWLS</td></tr><tr><td>Country</td><td>Myanmar</td></tr><tr><td>Sub-National</td><td>Sittoung</td></tr><tr><td>Type of Station</td><td></td></tr><tr><td>Type of Operation</td><td></td></tr><tr><td>Technical Specs</td><td></td></tr><tr><td>Data transmission</td><td></td></tr><tr><td>Date of establishment</td><td></td></tr><tr><td>Source of Funds</td><td></td></tr><tr><td>Status</td><td></td></tr></table>",
  },
  {
    name: "Madauk WLS",
    lat: 17.92,
    lng: 96.85,
    description:
      "<table><tr><td>Name of Station</td><td>Madauk WLS</td></tr><tr><td>Country</td><td>Myanmar</td></tr><tr><td>Sub-National</td><td>Sittoung</td></tr><tr><td>Type of Station</td><td></td></tr><tr><td>Type of Operation</td><td></td></tr><tr><td>Technical Specs</td><td></td></tr><tr><td>Data transmission</td><td></td></tr><tr><td>Date of establishment</td><td></td></tr><tr><td>Source of Funds</td><td></td></tr><tr><td>Status</td><td></td></tr></table>",
  },
  {
    name: "Myitkyina WLS",
    lat: 25.37,
    lng: 97.35,
    description:
      "<table><tr><td>Name of Station</td><td>Myitkyina WLS</td></tr><tr><td>Country</td><td>Myanmar</td></tr><tr><td>Sub-National</td><td>Ayeyarwady</td></tr><tr><td>Type of Station</td><td></td></tr><tr><td>Type of Operation</td><td></td></tr><tr><td>Technical Specs</td><td></td></tr><tr><td>Data transmission</td><td></td></tr><tr><td>Date of establishment</td><td></td></tr><tr><td>Source of Funds</td><td></td></tr><tr><td>Status</td><td></td></tr></table>",
  },
  {
    name: "Katha WLS",
    lat: 24.17,
    lng: 96.33,
    description:
      "<table><tr><td>Name of Station</td><td>Katha WLS</td></tr><tr><td>Country</td><td>Myanmar</td></tr><tr><td>Sub-National</td><td>Ayeyarwady</td></tr><tr><td>Type of Station</td><td></td></tr><tr><td>Type of Operation</td><td></td></tr><tr><td>Technical Specs</td><td></td></tr><tr><td>Data transmission</td><td></td></tr><tr><td>Date of establishment</td><td></td></tr><tr><td>Source of Funds</td><td></td></tr><tr><td>Status</td><td></td></tr></table>",
  },
  {
    name: "Hkamti WLS",
    lat: 26,
    lng: 95.7,
    description:
      "<table><tr><td>Name of Station</td><td>Hkamti WLS</td></tr><tr><td>Country</td><td>Myanmar</td></tr><tr><td>Sub-National</td><td>Chindwin</td></tr><tr><td>Type of Station</td><td></td></tr><tr><td>Type of Operation</td><td></td></tr><tr><td>Technical Specs</td><td></td></tr><tr><td>Data transmission</td><td></td></tr><tr><td>Date of establishment</td><td></td></tr><tr><td>Source of Funds</td><td></td></tr><tr><td>Status</td><td></td></tr></table>",
  },
  {
    name: "Mawlaik WLS",
    lat: 23.63,
    lng: 94.42,
    description:
      "<table><tr><td>Name of Station</td><td>Mawlaik WLS</td></tr><tr><td>Country</td><td>Myanmar</td></tr><tr><td>Sub-National</td><td>Chindwin</td></tr><tr><td>Type of Station</td><td></td></tr><tr><td>Type of Operation</td><td></td></tr><tr><td>Technical Specs</td><td></td></tr><tr><td>Data transmission</td><td></td></tr><tr><td>Date of establishment</td><td></td></tr><tr><td>Source of Funds</td><td></td></tr><tr><td>Status</td><td></td></tr></table>",
  },
  {
    name: "Mawlaik AWS",
    lat: 23.63,
    lng: 94.42,
    description:
      "<table><tr><td>Name of Station</td><td>Mawlaik AWS</td></tr><tr><td>Country</td><td>Myanmar</td></tr><tr><td>Sub-National</td><td>Chindwin</td></tr><tr><td>Type of Station</td><td></td></tr><tr><td>Type of Operation</td><td></td></tr><tr><td>Technical Specs</td><td></td></tr><tr><td>Data transmission</td><td></td></tr><tr><td>Date of establishment</td><td></td></tr><tr><td>Source of Funds</td><td></td></tr><tr><td>Status</td><td></td></tr></table>",
  },
  {
    name: "Machanbaw AWS",
    lat: 26.5,
    lng: 97.23,
    description:
      "<table><tr><td>Name of Station</td><td>Machanbaw AWS</td></tr><tr><td>Country</td><td>Myanmar</td></tr><tr><td>Sub-National</td><td>Ayeyarwady</td></tr><tr><td>Type of Station</td><td></td></tr><tr><td>Type of Operation</td><td></td></tr><tr><td>Technical Specs</td><td></td></tr><tr><td>Data transmission</td><td></td></tr><tr><td>Date of establishment</td><td></td></tr><tr><td>Source of Funds</td><td></td></tr><tr><td>Status</td><td></td></tr></table>",
  },
]

export default MAP004
